<div class="content-header-title navbar-brand"><ng-content></ng-content></div>